<template>
    <div onwaiting="" :class="{sticky: scrollPosition < 160, sticked: scrollPosition > 160}" >
        <mdb-card class="p-2 d-none">
            <div sticky-container>
                <div v-sticky sticky-offset="offset" sticky-side="top">
                    <p class="text-muted">Fiyat geçerlilik süresi<br/>
                        bitmeden satın almanızı yapın</p>
                    <countdown class="bb-countdown" :class="{'alert-danger': isDanger }"   :time="920000" :transform="transform">
                        <template  slot-scope="props" >{{ props.minutes }}:{{ props.seconds }} <mdb-icon icon="stopwatch" /></template>
                    </countdown>
                </div>
            </div>
        </mdb-card>
        <mdb-card class="p-2 mt-1 d-none d-md-block d-lg-block" style="background-color: #3699d4">
            <div sticky-container>
                <div v-sticky sticky-offset="offset" sticky-side="top">
                    <div class="row">
                        <div class="col-1">
                        </div>
                        <div class="col-11">
                            <div class="sticky-info">
                                <h3 style="border-bottom: 1px solid ">{{fromCity}}</h3>
                                <div class="text-white">
                                    <span><b>Gidiş:</b> {{ fromDate | moment("Do MMMM YYYY") }}</span>
                                    <span>{{ fromDate | moment("dddd") }} {{departure_time}}</span>
                                </div>
                            </div>
                            <div class="sticky-info">
                                <h3 style="border-bottom: 1px solid ">{{toCity}}</h3>
                                <span v-if="toDate!=='null'"><b>Dönüş:</b> {{ toDate | moment("Do MMMM YYYY") }}</span>
                                <span v-if="toDate!=='null'">{{ toDate | moment("dddd") }} {{return_time}}</span>
                            </div>
                        </div>
                        <div class="col-1">
                        </div>
                        <div class="col-11">
                            <div class="sticky-info">
                                <p class="text-white mb-0">{{adult}} Yetişkin {{child>0?"- "+child+" Çocuk":""}} {{infant>0?" -"+infant+" Bebek":""}}</p>
                                <h3>{{total_fare}} ₺</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mdb-card>

    </div>
</template>

<script>
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption } from 'mdbvue';

    // In your VueJS component.
    import { VueperSlides, VueperSlide } from 'vueperslides'

    // Since v. 1.6.0, you need to include Vueper Slides CSS file for default styles.
    import 'vueperslides/dist/vueperslides.css'

    export default {
        name: "searchBar",
        components: {
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,
            VueperSlides,
            VueperSlide,
        },
        data() {
            return {
                scrollPosition: null,
                isDanger : false,
                flightType:localStorage.flight_type,
                fromAir:localStorage.from_code,
                fromIsCity:localStorage.from_is_city,
                fromCity:localStorage.from_city_name,
                fromCountry:localStorage.from_country_code,
                toAir:localStorage.to_code,
                toIsCity:localStorage.to_is_city,
                toCity:localStorage.to_city_name,
                toCountry:localStorage.to_country_code,
                fromDate:localStorage.departure_date,
                toDate:localStorage.return_date,
                adult:localStorage.adult,
                child:localStorage.child,
                infant:localStorage.infant,
                total_fare:localStorage.total_fares,
                departure_time:localStorage.departure_time,
                return_time:localStorage.return_time,
            }

        },

        methods: {
            updateScroll() {
                this.scrollPosition = window.scrollY
            },
            transform(props) {
                Object.entries(props).forEach(([key, value]) => {
                    // Adds leading zero
                    const digits = value < 10 ? `0${value}` : value;

                // uses singular form when the value is less than 2
                const word = value < 2 ? key.replace(/s$/, '') : key;

                props[key] = `${digits}`;

            });

                return props;
            },
        },
        mounted() {
            this.total_fare=localStorage.total_fares;
            window.addEventListener('scroll', this.updateScroll);

            console.log(localStorage.total_fares);
            console.log(this.total_fare);
        }

    }
</script>

<style scoped>

</style>
